import '@/js/dist/www.iichi.com/common';

import { createApp } from 'vue';
import UnsubscribeForm from '@/js/components/www.iichi.com/pages/newsletter/UnsubscribeForm.vue';

document.addEventListener('DOMContentLoaded', () => {
  createApp(UnsubscribeForm).mount('unsubscribe-form');
});
